import { StyleSheet } from "aphrodite";
import { textColor } from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IStyle {
  icon: any;
  address: any;
}

export const HeaderStyle: IStyle = StyleSheet.create({
  icon: {
    verticalAlign: "middle",
    fontSize: "1.3rem",
    position: "relative",
    left: "-2px",
    color: textColor.disabledColor,
  },
  address: {
    verticalAlign: "middle",
  },
  addressBlock: {
    padding: space.atom,
  },
});
